<template>
  <div class="home">
    <FourOFour />
  </div>
</template>

<script>
// @ is an alias to /src
import FourOFour from '@/views/404.vue'

export default {
  name: 'Home',
  components: {
    FourOFour
  }
}
</script>
